/** Agent-facing preamble for sessions forked from a parent (MCP tools serve full parent history). */
export function buildForkedSessionAgentPrompt(
  userPrompt: string,
  childSessionId: string,
  parentSessionId: string,
): string {
  const childRef = childSessionId.trim();
  const parentRef = parentSessionId.trim();
  return [
    'You are working in a new session that was forked from a prior session.',
    `This forked session id: ${childRef}`,
    `Parent session id: ${parentRef}`,
    '',
    'The parent session history is available through MCP tools on the buildautomaton-bridge server:',
    '- list_parent_session_prompts — list each user prompt / turn in the parent session',
    '- get_parent_session_turn_transcript — full transcript for one turn (including tool calls); requires turnId',
    '',
    'When calling these tools, always pass this forked session id as sessionId (not the parent session id).',
    '',
    'Use these tools when you need prior context instead of guessing.',
    '',
    'User request:',
    userPrompt.trim(),
  ].join('\n');
}
